export default __webpack_public_path__ + "static/media/152w.8e6f3495.svg";